module.exports = __webpack_public_path__ + "7ea5f18861fca1d59bde6206e2f5ebb1.MP3";